import { useI18n } from 'vue-i18n'

const useRechargeStore = defineStore(
  // 唯一ID
  'recharge',
  () => {
    const { t } = useI18n()
    const openRecharge = ref(false)
    const rechargeAuditStatusList = ref([
      {
        label: t('recharge_state_list[0]'),
        value: 0,
        tag_type: 'tag_primary',
      },
      {
        label: t('recharge_state_list[1]'),
        value: 1,
        tag_type: 'tag_success',
      },
      {
        label: t('recharge_state_list[2]'),
        value: 2,
        tag_type: 'tag_danger',
      },
    ])
    const rechargePayList = ref([
      {
        label: t('pay_type_list[0]'),
        value: 1,
        pay_logo_icon: 'alipay_pay',
      },
      {
        label: t('pay_type_list[1]'),
        value: 2,
        pay_logo_icon: 'we_chat_pay',
      },
      {
        label: t('pay_type_list[2]'),
        value: 3,
        pay_logo_icon: 'bank_card_pay',
      },
    ])
    const changeTypeList = ref([
      {
        label: t('fund_change_type[0]'),
        value: 1,
        select_show: true,
      },
      {
        label: t('fund_change_type[1]'),
        value: 2,
        select_show: false,
      },
      {
        label: t('fund_change_type[2]'),
        value: 3,
        select_show: false,
      },
      {
        label: t('fund_change_type[3]'),
        value: 4,
        select_show: true,
      },
      {
        label: t('fund_change_type[4]'),
        value: 5,
        select_show: true,
      },
    ])

    // 查询指定审核状态
    function findRechargeAuditStatusList(value: number) {
      return rechargeAuditStatusList.value.find(option => option.value === value)
        ?? {
          label: '',
          value: null,
          tag_type: '',
        }
    }
    // 查询指定支付类型
    function findRechargePayList(value: number) {
      return rechargePayList.value.find(option => option.value === value)
        ?? {
          label: '',
          value: null,
          pay_logo_icon: 'i-ep:question-filled',
        }
    }
    // 查询资金变动类型
    function findChangeTypeList(value: number) {
      return changeTypeList.value.find(option => option.value === value)
        ?? {
          label: '',
          value: null,
        }
    }
    return {
      openRecharge,
      rechargeAuditStatusList,
      rechargePayList,
      changeTypeList,
      findRechargeAuditStatusList,
      findRechargePayList,
      findChangeTypeList,
    }
  },
)

export default useRechargeStore
